import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Form, Control, Errors, actions} from 'react-redux-form'
import {Row, Col, FormGroup, FormControl, ControlLabel, Button, Checkbox, Radio} from 'react-bootstrap'
import LayoutContainer from "../../../layout/layout-container/index";
import ErrorMessages from '../../login/error-messages'
import ArrowButton from '../../../common/button-arrow'
import Can, {checkPermission} from "../../../common/guards/can";
import {convertPoints, savePpcLoad} from '../../../../actions/ppc'
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredSelect from '../../../common/form/elements/required-select';

class PpcLoadForm extends Component {

  constructor(props) {
    super(props);
  }

  convertPointsToEuros = (points) => {
    const {dispatch} = this.props;
    dispatch(convertPoints(points, this.props.links["convert-to-value"], 'deep.admin_ppc.management.load.value'));
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.management.load', savePpcLoad(this.props.userId, this.props.loadId, payLoad)));
  };

  render() {
    return (
      <LayoutContainer>
        <Form model="deep.admin_ppc.management.load"
              onSubmit={this.onSubmit}>
          <Errors className="errors" model="deep.admin_ppc.management.load" component={ErrorMessages}/>
          <Row>
            <Col lg={12}>
              <RequiredInput model=".points"
                             placeholder="e.g. 200"
                             label="Load value (points)"
                             onChange={this.convertPointsToEuros}
                             controlId="loadPoints"/>

              <RequiredInput model=".value"
                             placeholder="e.g. 20"
                             label="Load value (€)"
                             controlId="loadValue"
                             readOnly/>

              <RequiredSelect model=".status"
                              values={this.props.statuses}
                              hasEmptyValue={false}
                              controlId="orderStatus"
                              label="Order status"/>
            </Col>

          </Row>
          <Row>
            <ArrowButton className="pull-right"
                         disabled={!this.props.formValid}>Save</ArrowButton>
          </Row>
        </Form>
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_ppc.management.load.$form.valid,
    links: state.ppc.loadLinks
  };
};

export default connect(mapStateToProps)(PpcLoadForm);


// WEBPACK FOOTER //
// ./src/components/admin/ppc/load/ppc-load-form.jsx